import { useQuery } from "react-query";
import { useLogs } from "./useLogs";
import { FilterLogIvideonIProps } from "../model/schema";

interface useGetIvideonLogsIProps extends FilterLogIvideonIProps {
  send?: boolean;
}

export const useGetIvideonLogs = ({
  send,
  limit,
  page,
  dataFilter,
}: useGetIvideonLogsIProps) => {
  const { getIvideonLogs } = useLogs();

  const { data, isLoading, isError } = useQuery({
    queryKey: [
      "getIvideonLogs",
      limit,
      page,
      dataFilter ? JSON.stringify(dataFilter) : "",
    ],
    queryFn: () => getIvideonLogs({ limit, page, ...dataFilter }),
    enabled: send,
  });
  return { data: data?.data, isLoading, isError };
};
